(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nd-f-main-product"]) return;
  try {
    
(() => {
  const init = root => root.querySelectorAll('[data-f-prod-sec]').forEach(section => {
    const dialog = section.querySelector('[data-f-gallery-dialog]');
    const links = [...section.querySelectorAll('[data-f-gallery-open]')];
    if (!dialog || !links.length || dialog.dataset.ready || !dialog.showModal) return;
    dialog.dataset.ready = 'true';
    const img = dialog.querySelector('[data-f-gallery-image]');
    const stage = dialog.querySelector('[data-f-gallery-stage]');
    const zoom = dialog.querySelector('[data-f-gallery-zoom]');
    let index = 0, opener, oldOverflow = '', start;
    const resetZoom = () => { stage.classList.remove('is-zoomed'); zoom.setAttribute('aria-pressed', 'false'); stage.scrollTo(0,0); };
    const show = i => {
      index = (i + links.length) % links.length;
      const source = links[index].querySelector('img');
      const url = new URL(source.getAttribute('src') || links[index].href, location.href);
      url.searchParams.set('width', '2400');
      img.src = url.href; img.alt = source.alt;
      dialog.querySelector('[data-f-gallery-caption]').textContent = source.alt;
      dialog.querySelector('[data-f-gallery-count]').textContent = `${index + 1} / ${links.length}`;
      resetZoom();
    };
    const toggleZoom = () => { const on = stage.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed', String(on)); if (!on) stage.scrollTo(0,0); };
    links.forEach((link,i) => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); opener=link; show(i); oldOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden'; dialog.showModal();
    }));
    dialog.querySelector('[data-f-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-f-gallery-prev]').addEventListener('click', () => show(index-1));
    dialog.querySelector('[data-f-gallery-next]').addEventListener('click', () => show(index+1));
    zoom.addEventListener('click', toggleZoom);
    img.addEventListener('click', toggleZoom);
    dialog.addEventListener('close', () => { document.documentElement.style.overflow=oldOverflow; resetZoom(); opener?.focus({preventScroll:true}); });
    dialog.addEventListener('click', event => { if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();} });
    dialog.addEventListener('keydown', event => { if(stage.classList.contains('is-zoomed')) return; if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);} });
    stage.addEventListener('touchstart', event => { start=event.touches.length===1&&!stage.classList.contains('is-zoomed')?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null; }, {passive:true});
    stage.addEventListener('touchend', event => {if(!start||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>70&&Math.abs(dx)>Math.abs(dy)*1.5)show(index+(dx<0?1:-1));}, {passive:true});
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
